import { useMutation } from '@tanstack/react-query'
import { acceptedTerms } from '../../service/user'

function useTerms() {
  return useMutation({
    mutationKey: ['terms'],
    mutationFn: acceptedTerms,
  })
}

export default useTerms
